<template>
  <div class="scriptsExamineListContainer">
    <section class="tab-container">
      <ul class="tabs">
        <li :class="{ active: activeName === '0' }" @click="handleTypeClick('0')">
          全部
        </li>
        <li :class="{ active: activeName === '1' }" @click="handleTypeClick('1')">
          图文
        </li>
        <li :class="{ active: activeName === '2' }" @click="handleTypeClick('2')">
          视频
        </li>
        <li :class="{ active: activeName === '3' }" @click="handleTypeClick('3')">
          图集
        </li>
        <li :class="{ active: activeName === '4' }" @click="handleTypeClick('4')">
          合集
        </li>
        <li :class="{ active: activeName === '6' }" @click="handleTypeClick('6')">
          帖子
        </li>
      </ul>
      <el-dropdown v-if="showAdd">
        <el-button size="mini" type="primary">
          写稿<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="toAdd(1)">文章</el-dropdown-item>
          <el-dropdown-item @click.native="toAdd(2)">视频</el-dropdown-item>
          <el-dropdown-item @click.native="toAdd(3)">图集</el-dropdown-item>
          <el-dropdown-item @click.native="toAdd(4)">合集</el-dropdown-item>
          <el-dropdown-item @click.native="toAdd(6)">帖子</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </section>

    <div class="packTypeContain" v-if="activeName == 4">
      <div class="packInnerContain">
        <div class="packTypeItem" :class="{ 'packTypeActive': packTypeIndex == 0 }" @click="getPackList(1)">文章</div>
        <div class="packTypeItem" :class="{ 'packTypeActive': packTypeIndex == 1 }" @click="getPackList(2)">视频</div>
      </div>
      <div class="addPackBtn" @click="toAddPack()">创建合集</div>
    </div>

    <!--    筛选栏-->
    <div class="searchContainer" v-if="activeName != 6">
      <el-date-picker v-model="searchDuration" type="daterange" align="right" unlink-panels range-separator="至"
        start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp" @change="handleFilterChange">
      </el-date-picker>
      <el-input placeholder="请输入关键词" v-model="searchKey" clearable class="searchKeyInput" @change="handleFilterChange">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <!--状态筛选栏-->

    <ul class="statusBtns" v-if="activeName == 6">
      <li v-for="(postItem, postIndex) in postTabs" :key="postIndex" @click="handleStatusClick(postIndex)"
        class="statusBtn" :class="{ active: statusIndex == postIndex }">
        {{ postItem.name }}
      </li>
    </ul>
    <ul class="statusBtns" v-if="activeName != 6">
      <li v-for="(item, index) in tabs" :key="index" @click="handleStatusClick(index)" class="statusBtn"
        :class="{ active: statusIndex == index }">
        {{ item.name }}
      </li>
    </ul>

    <div class="innerContainer">
      <ul class="scriptList" v-if="activeName < 4 || activeName == 6">
        <li v-for="(item, index) in list" :key="index">
          <div class="cover-container" v-if="item.n_cover_url && item.n_cover_url.length > 0">
            <!-- <el-image
              class="cover"
              fit="cover"
              :src="item.n_cover_url[0]"
              :preview-src-list="item.n_cover_url"
            /> -->
            <img :src="item.n_cover_url[0]" class="cover" @click="toDetail(item)" />
          </div>
          <div class="info-box">
            <div class="infoContainer">
              <div class="titleContainer">
                <p class="title" @click="toDetail(item)" :class="{ outlineList: statusIndex == 6 }"
                  v-html="item.n_title"></p>
                <p class="noPassReason" v-if="statusIndex == 3 && activeName != 6">
                  未通过原因：{{ item.n_audit_result || "无" }}
                </p>
                <p class="noPassReason" v-if="
                  (activeName == 6 && item.status == 3) || item.status == 4
                ">
                  未通过原因：{{ item.reason || "无" }}
                </p>
              </div>
              <div class="timeContainer">
                <img src="../../../assets/script/dings.png" class="pubNowIcon" v-if="statusIndex == 5" />
                <p class="create-time">
                  {{
                    statusIndex == 5 ? item.nm_clock_time : item.n_create_time
                  }}
                </p>
              </div>
            </div>
            <div class="infoContainer" style="display: block" :style="{
              visibility:
                statusIndex == 0 && activeName != 6 ? 'visible' : 'hidden',
            }">
              <p class="status" v-if="item.n_release_status != 2">
                <span :class="convertStatus(item.n_release_status)"
                  v-if="item.n_release_status != 0 || item.clock_not_send != 1">
                  {{ item.n_release_status | getStatusName }}
                </span>
                <span class="info clockPubStutas"
                  v-if="item.n_release_status == 0 && item.clock_not_send == 1">定时未发布</span>
              </p>
              <p class="noPassReason" style="max-width: calc(100% - 230px)" v-if="[2].includes(item.n_release_status)">
                未通过：{{ item.n_audit_result || "无" }}
              </p>
            </div>
            <div class="infoContainer action-bar">
              <!--已采用才展示-->
              <div class="userSetTop" v-if="item.is_pinned">置顶</div>
              <div class="ext-info" v-if="item.n_id">
                <span v-if="item.watch_num !== undefined">展现 {{ item.watch_num }}</span>
                <span v-if="statusIndex != 6">评论 {{ item.comment_num }}</span>
                <span v-if="item.like_num !== undefined">点赞 {{ item.like_num }}</span>
              </div>
              <div class="actionContainer" v-if="statusIndex != 6">
                <p class="btns" v-if="
                  (((statusIndex != 2 &&
                    item.n_release_status != 1 &&
                    item.n_release_status !== null) ||
                    statusIndex == 3) &&
                    activeName != 6) ||
                  (activeName == 6 && item.status != 0)
                ">
                  <span @click="toEdit(item)">修改</span>
                </p>
                <p class="btns" v-if="
                  (item.n_id && activeName != 6) ||
                  item.status == 1 ||
                  item.status == 2
                ">
                  <span @click="showComments(item)">查看评论</span>
                </p>
                <p class="btns" v-if="
                  (item.n_id && item.n_only_me_see != 1 && activeName != 6) ||
                  ((item.status == 1 || item.status == 2) &&
                    item.only_me_see != 1)
                ">
                  <span @click="preview(item)">预览</span>
                </p>
                <el-dropdown trigger="click" class="btns">
                  <span class="el-dropdown-link">更多</span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-if="item.n_id && (item.n_type == 1 || item.n_type == 2 || item.nm_type == 1 || item.nm_type == 2)"><span
                        @click="openPack(item)" class="scriptDrop">加入合集</span></el-dropdown-item>
                    <el-dropdown-item v-if="item.n_id"><span @click="topNow(item)" class="scriptDrop">{{
                      item.is_pinned ? "取消置顶" : "置顶"
                        }}</span></el-dropdown-item>
                    <el-dropdown-item v-if="
                      item.n_id &&
                      (statusIndex == 0 || statusIndex == 1) &&
                      activeName != 6 &&
                      item.nm_type != 6
                    "><span @click="operateComment(item)" class="scriptDrop">{{
                      item.n_is_allow_comment == "Y" ? "关闭评论" : "开启评论"
                    }}</span></el-dropdown-item>
                    <el-dropdown-item v-if="
                      item.n_id &&
                      (statusIndex == 0 || statusIndex == 1) &&
                      activeName != 6 &&
                      item.nm_type != 6 &&
                      reward_auth
                    "><span @click="operateReward(item)" class="scriptDrop">{{
                      item.n_reward == 1 ? "关闭打赏" : "开启打赏"
                    }}</span></el-dropdown-item>
                    <el-dropdown-item v-if="
                      item.n_id &&
                      (statusIndex == 1 || statusIndex == 4) &&
                      activeName != 6
                    "><span @click="operateOnlyMe(item, index)" class="scriptDrop">{{
                      item.n_only_me_see == "1"
                        ? "取消仅我可见"
                        : "仅我可见"
                    }}</span></el-dropdown-item>
                    <el-dropdown-item v-if="
                      item.status == 1 ||
                      item.status == 2 ||
                      (activeName == 6 && statusIndex == 3)
                    "><span @click="operateOnlyMePost(item, index)" class="scriptDrop">{{
                      item.only_me_see == "1" ? "取消仅我可见" : "仅我可见"
                    }}</span></el-dropdown-item>
                    <el-dropdown-item v-if="
                      (statusIndex == 2 ||
                        item.n_release_status == 1 ||
                        item.n_release_status === null) &&
                      statusIndex != 3 &&
                      item.nm_type != 6 &&
                      activeName != 6
                    "><span @click="cancelAudit(item)" class="scriptDrop">撤回</span></el-dropdown-item>
                    <el-dropdown-item v-if="
                      statusIndex == 5 ||
                      (item.n_release_status == 0 && item.clock_not_send == 1)
                    "><span @click="pubNow(item)" class="scriptDrop">立即发布</span></el-dropdown-item>
                    <el-dropdown-item>
                      <span @click="toDelete(item, index)" class="scriptDrop">删除</span></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div class="auditLeft" v-if="item.audit_need_minute !== undefined && statusIndex == 2">
              预计审核时长：{{
                item.audit_need_minute === 0
                  ? "继续等待"
                  : item.audit_need_minute + "分钟"
              }}
            </div>
          </div>
        </li>
      </ul>
      <ul class="scriptList" v-else>
        <li v-for="(item, index) in list" :key="index">
          <div class="cover-container" v-if="item.cover_url">
            <!-- <el-image
              class="cover"
              fit="cover"
              :src="item.cover_url"
              :preview-src-list="[item.cover_url]"
              lazy
              v-if="item.cover_url"
            /> -->
            <img :src="item.cover_url" class="cover" />
          </div>
          <div class="info-box">
            <div class="infoContainer">
              <p class="title">{{ item.title }}</p>
              <p class="create-time" style="flex-shrink: 0">
                {{ item.create_time }}
              </p>
            </div>
            <div class="infoContainer" :style="{ visibility: statusIndex == 0 ? 'visible' : 'hidden' }">
              <p class="status">
                <span :class="convertStatusForVideoPack(item.audit_status)">
                  {{ item.audit_status | getStatusNameForVideoPack }}
                </span>
              </p>
            </div>
            <div class="infoContainer action-bar">
              <div class="ext-info">
                <span>{{ packTypeIndex == 0 ? '文章' : '视频' }} {{ item.video_num }}</span>
              </div>
              <div class="actionContainer">
                <!-- <p class="btns" v-if="[6, 7].includes(item.audit_status)"> -->
                <p class="btns" v-if="item.audit_status != 0">
                  <span @click="toEdit(item)">修改</span>
                </p>
                <p class="btns" v-if="[6].includes(item.audit_status) && item.id > 0">
                  <span @click="preview(item)">预览</span>
                </p>
                <el-dropdown trigger="click" class="btns">
                  <span class="el-dropdown-link">更多</span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item><span @click="toDelete(item, index)"
                        class="scriptDrop">删除</span></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <el-empty description="暂无内容" v-if="list.length === 0"></el-empty>
      <el-pagination background :current-page="currentPage"
        :page-size="activeName == 0 && statusIndex == 0 ? 20 : pageSize" layout="total, prev, pager, next, jumper"
        :total="total" @current-change="handleCurrentChange" />
      <div class="clear"></div>
    </div>

    <el-dialog :visible.sync="previewVisible" width="626px" top="5vh" class="previewContainer">
      <section slot="title">
        <span class="title">预览</span>
        <template v-if="
          previewDetail.n_release_status === 0 && previewDetail.share_h5_url
        ">
          <el-link type="primary" :href="previewUrl" target="_blank">
            {{ previewUrl }}
          </el-link>
          <span @click="handleCopyPreviewLink(previewUrl)" class="copy-btn">
            复制链接
          </span>
        </template>
      </section>
      <div class="" style="
          width: 100%;
          display: flex;
          justify-content: center;
          min-height: 400px;
          height: 700px;
        ">
        <iframe :src="this.previewUrl" style="width: 100%" frameborder="0"></iframe>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="commentVisible" width="920px" top="5vh" class="commentContainer">
      <div class="scriptActiveContainer">
        <el-image class="cover" fit="cover" :src="scriptActive.n_cover_url[0]"
          :preview-src-list="scriptActive.n_cover_url" v-if="scriptActive.n_cover_url.length > 0" />
        <div>
          <p class="scriptTitle">{{ scriptActive.n_title }}</p>
          <p class="scriptTime">{{ scriptActive.n_create_time }}</p>
        </div>
      </div>
      <p class="commentCount">共{{ scriptActive.comment_num }}条评论</p>
      <ul class="commentList" v-infinite-scroll="getComments" infinite-scroll-distance="80"
        infinite-scroll-disabled="commentBusy" style="overflow-y: auto">
        <li v-for="(item, index) in commentList" :key="index">
          <img src="../../../assets/commentIcon/light.png" class="specialIcon" v-if="item.tag_id == 1" />
          <img src="../../../assets/commentIcon/god.png" class="specialIcon" v-if="item.tag_id == 2" />
          <div class="headContainer">
            <img :src="item.u_avatar" class="head" />
            <p class="userName">{{ item.u_nickname }}</p>
          </div>
          <div class="contentContainer">
            <p class="isTop" v-if="item.c_is_top > 0">置顶</p>
            <div class="content" :class="{ contentIsTop: item.c_is_top > 0 }">
              {{ item.c_content }}
            </div>
          </div>
          <el-image fit="cover" :src="item.c_content_img_url" :preview-src-list="[item.c_content_img_url]"
            class="commentImg" :style="item | commentImgSize(findNearesttargetber)" v-if="item.c_content_img_url" />
          <div class="actionContainer">
            <p class="commentTime">{{ item.display_time }}</p>
            <div class="actions">
              <div class="action" @click="replyToggle(item)">
                <img src="../../../assets/commentIcon/comment.png" class="actionIcon" />
                <p class="actionName">
                  {{
                    item.showReply
                      ? "取消回复"
                      : item.comment_num > 0
                        ? item.comment_num
                        : "回复"
                  }}
                </p>
              </div>
              <div class="action" @click="commentLike(item)">
                <img src="../../../assets/commentIcon/like.png" class="actionIcon" v-if="item.is_like == 0" />
                <img src="../../../assets/commentIcon/zanR.png" class="actionIcon" v-else />
                <p class="actionName">{{ item.like_num }}</p>
              </div>
              <div class="action" @click="commentTop(item)" v-if="topAuth">
                <img src="../../../assets/commentIcon/top.png" class="actionIcon" v-if="item.c_is_top == 0" />
                <p class="actionName">
                  {{ item.c_is_top > 0 ? "取消置顶" : "置顶" }}
                </p>
              </div>
              <div class="action" @click="commentDelete(index)">
                <img src="../../../assets/commentIcon/delete.png" class="actionIcon" />
                <p class="actionName">删除</p>
              </div>
            </div>
          </div>
          <div class="commentReplyContainer" v-show="item.showReply">
            <el-input type="textarea" :rows="3" placeholder="积极回复用户，可以吸引更多的人评论哦～" v-model="item.reply" :autosize="true"
              resize="none">
            </el-input>
            <p class="replyBtn" :class="{ hasContent: item.reply != '' }" @click="commentReply(index)">
              发布
            </p>
            <div class="clear"></div>
          </div>
          <ul class="subCommentsContainer" v-if="item.children && item.children.length">
            <li v-for="(subItem, subIndex) in item.children" :key="subIndex">
              <img src="../../../assets/commentIcon/light.png" class="specialIcon" v-if="subItem.tag_id == 1" />
              <img src="../../../assets/commentIcon/god.png" class="specialIcon" v-if="subItem.tag_id == 2" />
              <div class="headContainer">
                <img :src="subItem.u_avatar" class="head" />
                <p class="userName">{{ subItem.u_nickname }}</p>
              </div>
              <div class="contentContainer">
                <p class="isTop" v-if="subItem.c_is_top > 0">置顶</p>
                <div class="content" :class="{ contentIsTop: subItem.c_is_top > 0 }">
                  回复<span class="toUserName">{{ subItem.to_u_nickname }}</span>{{ subItem.c_content }}
                </div>
              </div>
              <el-image fit="cover" :src="subItem.c_content_img_url" :preview-src-list="[subItem.c_content_img_url]"
                class="commentImg" :style="subItem | commentImgSize(findNearesttargetber)"
                v-if="subItem.c_content_img_url" />
              <div class="actionContainer">
                <p class="commentTime">{{ subItem.display_time }}</p>
                <div class="actions">
                  <div class="action" @click="replyToggle(subItem)">
                    <img src="../../../assets/commentIcon/comment.png" class="actionIcon" />
                    <p class="actionName">
                      {{
                        subItem.showReply
                          ? "取消回复"
                          : subItem.comment_num > 0
                            ? subItem.comment_num
                            : "回复"
                      }}
                    </p>
                  </div>
                  <div class="action" @click="commentLike(subItem)">
                    <img src="../../../assets/commentIcon/like.png" class="actionIcon" v-if="subItem.is_like == 0" />
                    <img src="../../../assets/commentIcon/zanR.png" class="actionIcon" v-else />
                    <p class="actionName">{{ subItem.like_num }}</p>
                  </div>
                  <div class="action" @click="commentDelete(index, subIndex)">
                    <img src="../../../assets/commentIcon/delete.png" class="actionIcon" />
                    <p class="actionName">删除</p>
                  </div>
                </div>
              </div>
              <div class="commentReplyContainer" v-show="subItem.showReply">
                <el-input type="textarea" :rows="3" placeholder="积极回复用户，可以吸引更多的人评论哦～" v-model="subItem.reply"
                  :autosize="true" resize="none">
                </el-input>
                <p class="replyBtn" :class="{ hasContent: subItem.reply != '' }" @click="commentReply(index, subIndex)">
                  发布
                </p>
                <div class="clear"></div>
              </div>
            </li>
          </ul>
          <p class="moreComment" v-if="
            item.children &&
            item.children.length &&
            item.children.length == item.comment_num > 1 &&
            item.comment_num > 1
          " @click="moreComment(index)">
            点击展开{{ item.comment_num - 1 }}条评论
          </p>
        </li>
      </ul>
    </el-dialog>

    <el-dialog title="请完成实名认证" :visible.sync="certificationVisible" class="certificationInfoContainer" width="1026px">
      <p class="title">
        应网络实名制要求，完成实名认证后才可以发表文章视频等内容，以保护账号安全。
      </p>
      <div class="borderContainer">
        <div>
          <p class="infoTitle">1、打开“顶端新闻”App</p>
          <p class="info">登录当前账号或扫下方二维码下载“顶端新闻”App</p>
          <img src="../../../assets/85d81507ebe84f210b224bf8e02c6d76966336a7fff89e02e5f088ed492cce1f.png"
            class="qrCode" />
        </div>
        <div>
          <p class="infoTitle">2、打开“我的”</p>
          <p class="info">点击“实名认证”完成实名认证</p>
          <img src="../../../assets/shiming@2x.png" class="app" v-if="u_cert != 1" />
          <img src="../../../assets/shenqing@2x.png" class="app" v-else />
        </div>
      </div>
    </el-dialog>

    <ViewDrawer :show="viewShow" :url="previewUrl" :urlMobile="previewUrlMobile" @close="previewUrlClose">
      <template #title>
        <div class="copyurl">
          <div class="urlTitle">网址预览</div>
          <div class="link">
            <el-link type="primary" :href="previewUrl" target="_blank">
              {{ previewUrl }}
            </el-link>
          </div>
          <span @click="handleCopyPreviewLink(previewUrl)" class="copy-btn">
            复制链接
          </span>
        </div>
        <div class="copyurl">
          <div class="urlTitle">手机网址</div>
          <div class="link">
            <el-link type="primary" :href="previewUrlMobile" target="_blank">
              {{ previewUrlMobile }}
            </el-link>
          </div>
          <span @click="handleCopyPreviewLink(previewUrlMobile)" class="copy-btn">
            复制链接
          </span>
        </div>
      </template>
    </ViewDrawer>

    <BanDialog ref="banShow" :isShow="isBanned" :allowClose="true" @closeBan="isBanned = false"></BanDialog>

    <el-dialog :visible.sync="editTimesVisible" title="稿件修改次数提醒" :close-on-click-modal="false" width="550px"
      class="editTimesContainer">
      <div class="editTimesContent">{{ editTimesObj.msg }}</div>
      <div slot="footer" class="dialog-footer">
        <div class="submitBtn" @click="editTimesVisible = false">取消</div>
        <div class="submitBtn" type="primary" @click="goEdit()" v-if="editTimesObj.status != 2">
          继续修改
        </div>
      </div>
    </el-dialog>

    <el-dialog title="" :visible.sync="topVisible" width="420px" class="topContainer">
      <div class="topTitle">确定将此内容置顶？</div>
      <div class="topIntro">
        同时仅支持一篇内容置顶，若你已经置顶其他内容，此内容将取代它作为指定内容。
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="submitBtn" @click="topVisible = false">取 消</div>
        <div class="submitBtn" type="primary" @click="topNow()">确 定</div>
      </div>
    </el-dialog>

    <el-dialog title="添加到合集中" :visible.sync="collectionAddVisible" width="1000px" top="5vh"
      class="collectionAddContainer">
      <el-input v-model="collectionAddKeyword" placeholder="请输入关键词" clearable class="collectionAddKeyword"
        @keyup.enter.native="getPackListDialog(1)" @clear="getPackListDialogClear()"></el-input>
      <el-button type="primary" @click="getPackListDialog(1)">查 询</el-button>
      <div class="videoCollectContainer publicScroll">
        <div v-for="(item, index) in collectionAddList" :key="index" class="scriptListItem"
          :class="{ 'collectionAddActive': collectionAddIndex == index }" @click="collectionAddIndex = index">
          <div class="bgContainer">
            <div class="cover-container" v-if="item.cover_url">
              <el-image class="cover" fit="cover" :src="item.cover_url" />
            </div>
            <div class="info-box">
              <div class="infoContainer">
                <p class="title">
                  {{ item.title }}
                </p>
              </div>
              <p class="create-time">发布于{{ item.create_time }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="searchNoDataContainer" v-if="collectionAddList.length == 0">
        <img src="../../../assets/script/no.png" class="noDataImg" />
        <p class="noDataText">暂无合集可选择，先去创作一个合集吧</p>
      </div>
      <el-pagination background :current-page="collectionAddCurrentPage" :page-size="collectionAddPageSize"
        layout="total, prev, pager, next, jumper" :total="collectionAddTotal"
        @current-change="handleCollectionAddCurrentChange" />
      <br />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toAddPack(1)">创建新合集</el-button>
        <div class="footerInner">
          <el-button @click="collectionAddVisible = false">取 消</el-button>
          <el-button type="primary" @click="addToPackFn">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  NEWS_HOST,
  RESOURCE_HOST,
  SWNEWS_HOST,
  BI_HOST,
} from "../../../constants/apiHosts";
import {
  MANUSCRIPT_STATUS,
  MANUSCRIPT_VIDEOPACK_STATUS,
  MANUSCRIPT_LIST_STATUS,
} from "../../../constants/manuscript";
import ViewDrawer from "@/components/ViewDrawer";
import BanDialog from "../../../components/banDialog.vue";
import dbRequest from "../../../plugin/request-bd";

export default {
  components: {
    ViewDrawer,
    BanDialog,
  },
  filters: {
    getStatusName: function (status) {
      return MANUSCRIPT_LIST_STATUS[status] || "审核中";
    },
    getStatusNameForVideoPack: function (status) {
      if (status == 6) {
        return "已发布";
      } else if (status == 7) {
        return "未通过";
      } else {
        return "审核中";
      }
    },
    commentImgSize(item, compute) {
      let rate = 1;
      if (item.c_content_img_width) {
        rate = compute(
          [0.5625, 1, 1.3333],
          item.c_content_img_width / item.c_content_img_height
        );
      }
      switch (rate) {
        case 0.5625:
          // 9:16
          return "width:180px;height:320px;";
        case 1:
          // 1:1
          return "width:240px;height:240px;";
        case 1.3333:
          // 4:3
          return "width:320px;height:240px;";
        default:
          return "width:240px;height:240px;";
      }
    },
  },
  computed: {
    tabs: function () {
      let tab = MANUSCRIPT_STATUS;
      if (this.activeName == 4) {
        tab = MANUSCRIPT_VIDEOPACK_STATUS;
      }
      return tab;
    },
  },
  data() {
    return {
      viewShow: false,
      activeName: "0",
      statusIndex: 0,
      searchKey: "",
      searchDuration: [],
      list: [],
      pageSize: 10,
      currentPage: 1,
      total: 1,
      previewDetail: {
        nm_resource_url: [],
      },
      previewVisible: false,
      u_avatar: "",
      u_nickname: "",
      u_cert: 0,
      u_cert_status: 0,
      certificationVisible: false,
      previewUrl: "",
      previewUrlMobile: "",
      commentVisible: false,
      scriptActive: {
        n_cover_url: [],
      },
      commentPage: 1,
      commentList: [],
      commentBusy: false,
      isBanned: false,
      topAuth: false,
      postTabs: [
        {
          id: 1,
          name: "已发布",
        },
        {
          id: 2,
          name: "审核中",
        },
        {
          id: 3,
          name: "未通过",
        },
        {
          id: 4,
          name: "仅我可见",
        },
      ],
      reward_auth: false,
      editTimesVisible: false,
      editTimesObj: {},
      editNewsObj: {},
      topVisible: false,
      topItem: {},
      packTypeIndex: 0,
      collectionAddVisible: false,
      collectionAddKeyword: "",
      collectionAddList: [],
      collectionAddCurrentPage: 1,
      collectionAddPageSize: 20,
      collectionAddTotal: 0,
      collectionAddItem: {},
      collectionAddIndex: -1
    };
  },
  props: {
    showAdd: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    this.u_cert_status = localStorage.getItem("u_cert_status");
    this.u_cert = localStorage.getItem("u_cert");

    setTimeout(() => {
      this.u_cert_status = localStorage.getItem("u_cert_status");
      this.u_cert = localStorage.getItem("u_cert");
    }, 3000);

    this.u_avatar = localStorage.getItem("u_avatar")
      ? localStorage.getItem("u_avatar")
      : require("../../../assets/moren.png");
    this.u_nickname = localStorage.getItem("u_nickname");

    this.getList();
    this.getUserLevelList();
    this.trackFn();
    this.getPackListDialog(1);
  },
  mounted() { },
  methods: {
    trackFn() {
      dbRequest({
        url: `${BI_HOST}/bd`,
        method: "POST",
        params: {
          b_type: "创作中台稿件库",
        },
      }).then((res) => {
        if (res.data.code == 200) {
        } else {
          //this.$message.error(res.data.msg);
        }
      });
    },
    getNowTime() {
      var date = new Date();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      return (
        month +
        "月" +
        date.getDate() +
        "日 " +
        date.getHours() +
        ":" +
        date.getMinutes()
      );
    },
    handleTypeClick(type) {
      this.activeName = type;
      this.currentPage = 1;
      if (
        this.activeName == 6 ||
        (this.activeName == 4 && this.statusIndex > 3)
      ) {
        this.statusIndex = 0;
      }
      if (this.activeName < 4 || this.activeName == 6) {
        this.getList();
      } else {
        this.getVideoPackList();
      }
    },
    handleFilterChange() {
      this.currentPage = 1;
      if (this.activeName < 4) {
        this.getList();
      } else {
        this.getVideoPackList();
      }
    },
    handleStatusClick(index) {
      this.statusIndex = index;

      this.currentPage = 1;
      if (this.activeName < 4 || this.activeName == 6) {
        this.getList();
      } else {
        this.getVideoPackList();
      }
    },
    reset() {
      this.statusIndex = 0;
      this.searchKey = "";
      this.searchDuration = [];

      this.currentPage = 1;
      if (this.activeName < 4 || this.activeName == 6) {
        this.getList();
      } else {
        this.getVideoPackList();
      }
    },
    getList() {
      let url = `${SWNEWS_HOST}/api/user/newsList?page=${this.currentPage
        }&size=${this.pageSize}&title=${this.searchKey}&tab=${this.tabs[this.statusIndex].id
        }&type=${this.activeName}`;
      if (this.searchDuration && this.searchDuration.length) {
        url += `&start_time=${this.searchDuration[0] / 1000}&end_time=${this.searchDuration[1] / 1000 + 86400
          }`;
      }
      if (this.tabs[this.statusIndex].id == 20) {
        url = `${SWNEWS_HOST}/api/user/manuscriptList?type=${this.activeName}&page=${this.currentPage}&size=${this.pageSize}&title=${this.searchKey}&audit_status=0`;
      }
      if (this.searchDuration && this.searchDuration.length) {
        url += `&start_time=${this.searchDuration[0] / 1000}&end_time=${this.searchDuration[1] / 1000 + 86400
          }`;
      }
      if (this.activeName == 6) {
        url = `${SWNEWS_HOST}/api/communityMyPost/getMyPostList?page=${this.currentPage
          }&size=${this.pageSize}&tab_type=${this.postTabs[this.statusIndex].id}`;
      }
      if (this.activeName == 0 && this.statusIndex == 0) {
        url = `${SWNEWS_HOST}/api/user/manuscriptAndPostList?page=${this.currentPage}&size=${this.pageSize}&title=${this.searchKey}`;
        if (this.searchDuration && this.searchDuration.length) {
          url += `&start_time=${this.searchDuration[0] / 1000}&end_time=${this.searchDuration[1] / 1000 + 86400
            }`;
        }
      }
      this.$axios.get(url).then((res) => {
        if (res.data.code == 0) {
          if (this.activeName == 6) {
            res.data.data.returnData.forEach((item) => {
              item.n_title = item.content;
              item.n_cover_url = item.cover_url;
              item.n_create_time = item.publish_time;
              item.n_type = 6;
              item.n_is_allow_comment = item.n_is_allow_share;
            });
          } else {
            res.data.data.returnData.forEach((item) => {
              if (item.nm_title) {
                item.n_title = item.nm_title;
                item.n_cover_url = item.nm_cover_url;
                item.n_create_time = item.nm_create_time;
                item.n_type = item.nm_type;
                item.n_is_allow_comment = item.nm_is_allow_comment;
                item.n_reward = item.nm_reward;
              } else if (item.n_type) {
                item.nm_type = item.n_type;
              }
            });
          }
          this.list = res.data.data.returnData;
          if (this.currentPage == 1) {
            if (this.activeName == 0 && this.statusIndex == 0) {
              this.total = res.data.data.count;
            } else {
              this.total = res.data.data.count;
            }
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getPackListDialog() {
      let url = `${RESOURCE_HOST}/api/newsPack/getList?page=${this.collectionAddCurrentPage
        }&size=${this.collectionAddPageSize}&title=${this.collectionAddKeyword}&audit_status=6&pack_type=${this.collectionAddItem.n_type == 1 || this.collectionAddItem.nm_type == 1 ? 1 : 2}`;
      this.$axios.get(url).then((res) => {
        if (res.data.code == 0) {
          this.collectionAddList = res.data.data.data;
          if (this.collectionAddCurrentPage == 1) {
            this.collectionAddTotal = res.data.data.total;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getPackListDialogClear() {
      this.collectionAddCurrentPage = 1;
      this.getPackListDialog();
      this.collectionAddIndex = -1;

      this.$nextTick(() => {
        document.getElementsByClassName("videoCollectContainer")[0].scrollTop = 0;
      })
    },
    handleCollectionAddCurrentChange(val) {
      this.collectionAddCurrentPage = val;
      this.getPackListDialog();
      this.collectionAddIndex = -1;

      this.$nextTick(() => {
        document.getElementsByClassName("videoCollectContainer")[0].scrollTop = 0;
      })
    },
    addToPackFn() {
      if (this.collectionAddIndex == -1) {
        this.$message({
          message: "请选择要添加到的合集",
          type: "warning",
        });
      } else {
        this.$axios.post(`${RESOURCE_HOST}/api/newsPack/append`, {
          nvpl_series_id: this.collectionAddList[this.collectionAddIndex].nvpl_series_id,
          n_id: this.collectionAddItem.n_id,
        }).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: `操作成功`,
              type: "warning",
            });

            this.collectionAddVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    openPack(item) {
      this.collectionAddItem = item;
      this.collectionAddVisible = true;

      this.getPackListDialogClear();
    },
    toAddPack(isDialog) {
      let packType = 1;
      if (isDialog) {
        if (this.collectionAddItem.n_type == 2 || this.collectionAddItem.nm_type == 2) {
          packType = 2;
        }
      } else {
        if (this.packTypeIndex == 1) {
          packType = 2;
        }
      }
      this.$router.push({
        path: `/pack?packType=${packType}`,
      });
    },
    getPackList(packType) {
      this.packTypeIndex = packType - 1;
      this.statusIndex = 0;
      this.searchKey = "";
      this.searchDuration = [];

      this.currentPage = 1;
      this.getVideoPackList(packType);
    },
    getVideoPackList(packType) {
      packType = packType == null ? 1 : packType;
      let url = `${RESOURCE_HOST}/api/newsPack/getList?page=${this.currentPage
        }&size=${this.pageSize}&title=${this.searchKey}&audit_status=${this.tabs[this.statusIndex].id
        }&pack_type=${this.packTypeIndex + 1}`;
      if (this.searchDuration && this.searchDuration.length) {
        url += `&start_time=${this.searchDuration[0] / 1000}&end_time=${this.searchDuration[1] / 1000 + 86400
          }`;
      }
      this.$axios.get(url).then((res) => {
        if (res.data.code == 0) {
          this.list = res.data.data.data;
          if (this.currentPage == 1) {
            this.total = res.data.data.total;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.activeName < 4 || this.activeName == 6) {
        this.getList();
      } else {
        this.getVideoPackList();
      }

      document.getElementsByTagName("html")[0].scrollTop = 0;
    },
    convertStatus(status) {
      switch (status) {
        case 0:
          return "success";
        case 2:
          return "error";
        default:
          return "info";
      }
    },
    convertStatusForVideoPack(status) {
      switch (status) {
        case 6:
          return "success";
        case 7:
          return "error";
        default:
          return "info";
      }
    },
    toDetail(item) {
      if (this.statusIndex == 6) {
        // 已下线
        return;
      }
      let _this = this;
      let query = {
        scriptId: item.nm_id,
        nid: item.n_id,
        isMine: 1,
        isPub: _this.statusIndex == 1 || _this.statusIndex == 4 ? 1 : 0,
      };
      if (item.n_type == 6 || item.nm_type == 6 || this.activeName == 6) {
        query.isPost = 1;
        query.nid = item.encode_id || item.encode_nid;
        delete query.scriptId;
      }
      if (!item.n_id || item.status == 3 || item.status == 4) {
        return;
      }
      let routeUrl = this.$router.resolve({
        path: "/scriptDetail",
        query: query,
      });
      window.open(routeUrl.href, "_blank");
    },
    toAdd(type) {
      if (this.u_cert != 1) {
        this.certificationVisible = true;
        return;
      }
      let banData = localStorage.getItem("banData");
      if (banData) {
        banData = JSON.parse(banData);
      }
      if (
        banData.ban_type == 1 &&
        ((type != 6 && banData.ban_range_type.indexOf("1") > -1) ||
          (type == 6 && banData.ban_range_type.indexOf("3") > -1))
      ) {
        this.$refs.banShow.getReason(localStorage.getItem("token"));
        this.isBanned = true;
        return;
      }

      if (type == 1) {
        //往写稿跳转
        let routeData = this.$router.resolve({
          path: "/scriptWrite",
          isMine: 1,
        });
        window.open(routeData.href, "_blank");
      } else if (type == 2) {
        //往视频跳转
        let routeData = this.$router.resolve({
          path: "/videoWrite",
          isMine: 1,
        });
        window.open(routeData.href, "_blank");
      } else if (type == 3) {
        //往图集跳转
        let routeData = this.$router.resolve({
          path: "/graphWrite",
          isMine: 1,
        });
        window.open(routeData.href, "_blank");
      } else if (type == 4) {
        //往合集跳转
        let routeData = this.$router.resolve({
          path: "/videoWrite?isPack=1",
        });
        window.open(routeData.href, "_blank");
      } else if (type == 6) {
        //往合集跳转
        let routeData = this.$router.resolve({
          path: "/post",
        });
        window.open(routeData.href, "_blank");
      }
    },
    toEdit(item) {
      if (this.u_cert != 1) {
        this.certificationVisible = true;
        return;
      }
      let banData = localStorage.getItem("banData");
      if (banData) {
        banData = JSON.parse(banData);
      }
      if (
        banData.ban_type == 1 &&
        ((item.n_type != 6 &&
          this.activeName != 6 &&
          banData.ban_range_type.indexOf("1") > -1) ||
          ((item.n_type == 6 || this.activeName == 6) &&
            banData.ban_range_type.indexOf("3") > -1))
      ) {
        this.$refs.banShow.getReason(localStorage.getItem("token"));
        this.isBanned = true;
        return;
      }

      let _this = this;
      if (this.activeName == 4) {
        //合集编辑
        let routeData = this.$router.resolve({
          path: "/pack",
          query: {
            packType: this.packTypeIndex == 0 ? 1 : 2,
            nvpl_series_id: item.nvpl_series_id,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (item.n_type == 6 || this.activeName == 6) {
        let routeData = this.$router.resolve({
          path: "/post",
          query: {
            nid: item.encode_id || item.encode_nid,
            id: item.nm_id || item.id || "",
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        this.getNewsAuditNum(item);
      }
    },
    getNewsAuditNum(item) {
      this.$axios
        .post(`${SWNEWS_HOST}/api/newsAudit/getNewsAuditNum`, {
          nm_id: item.nm_id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.editNewsObj = item;
            this.editTimesObj = res.data.data;
            if (this.editTimesObj.status == 0) {
              this.goEdit();
            } else {
              this.editTimesVisible = true;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    goEdit() {
      let _this = this;
      if (this.editNewsObj.nm_type == 1) {
        //往写稿跳转
        let routeData = this.$router.resolve({
          path: "/scriptWrite",
          query: {
            scriptId: this.editNewsObj.nm_id,
            isMine: 1,
            isPub: _this.statusIndex == 1 || _this.statusIndex == 4 ? 1 : 0,
            nid: this.editNewsObj.n_id,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (this.editNewsObj.nm_type == 2) {
        let routeData = this.$router.resolve({
          path: "/videoWrite",
          query: {
            scriptId: this.editNewsObj.nm_id,
            isMine: 1,
            isPub: _this.statusIndex == 1 || _this.statusIndex == 4 ? 1 : 0,
            nid: this.editNewsObj.n_id,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (this.editNewsObj.nm_type == 3) {
        let routeData = this.$router.resolve({
          path: "/graphWrite",
          query: {
            scriptId: this.editNewsObj.nm_id,
            isMine: 1,
            isPub: _this.statusIndex == 1 || _this.statusIndex == 4 ? 1 : 0,
            nid: this.editNewsObj.n_id,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    cancelAudit(item) {
      // if (this.u_cert != 1) {
      //   this.certificationVisible = true;
      //   return;
      // }
      this.$confirm("确定要撤回该篇文稿的审核吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`${RESOURCE_HOST}/api/manuscript/reset`, {
              id: item.nm_id,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: "撤回成功",
                  type: "success",
                });

                this.getList();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => { });
    },
    toDelete(item, index) {
      // if (this.u_cert != 1) {
      //   this.certificationVisible = true;
      //   return;
      // }
      if (item.n_type == 6 || this.activeName == 6) {
        this.$confirm("确定要删除该篇帖子吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios
              .post(`${SWNEWS_HOST}/api/communityMyPost/delPost`, {
                post_id: item.id || item.nm_id,
              })
              .then((res) => {
                if (res.data.code == 0) {
                  this.$message({
                    message: "删除成功",
                    type: "success",
                  });

                  this.list.splice(index, 1);
                } else {
                  this.$message.error(res.data.msg);
                }
              });
          })
          .catch(() => { });
      } else if (this.activeName < 4) {
        this.$confirm("确定要删除该篇文稿吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios
              .post(
                this.statusIndex == 1 || this.statusIndex == 4
                  ? `${NEWS_HOST}/api/news/del`
                  : `${RESOURCE_HOST}/api/manuscript/del`,
                {
                  ids:
                    this.statusIndex == 1 || this.statusIndex == 4
                      ? item.n_id + ""
                      : item.nm_id + "",
                  global_ids: item.global_id,
                }
              )
              .then((res) => {
                if (res.data.code == 0) {
                  this.$message({
                    message: "删除成功",
                    type: "success",
                  });

                  //this.getList();
                  this.list.splice(index, 1);
                } else {
                  this.$message.error(res.data.msg);
                }
              });
          })
          .catch(() => { });
      } else {
        this.$confirm("确定要删除该合集吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios
              .post(`${RESOURCE_HOST}/api/newsPack/del`, {
                nvpl_series_id: item.nvpl_series_id,
              })
              .then((res) => {
                if (res.data.code == 0) {
                  this.$message({
                    message: "删除成功",
                    type: "success",
                  });

                  this.getVideoPackList();
                } else {
                  this.$message.error(res.data.msg);
                }
              });
          })
          .catch(() => { });
      }
    },
    pubNow(item) {
      this.$confirm("立即发布这篇文章吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`${RESOURCE_HOST}/api/manuscript/sendNow`, {
              nm_id: item.nm_id + "",
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: "发布成功",
                  type: "success",
                });

                this.getList();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => { });
    },
    operateComment(item) {
      this.$axios
        .post(`${RESOURCE_HOST}/api/manuscript/opreateComment`, {
          n_id: item.n_id,
          is_allow_comment: item.n_is_allow_comment == "Y" ? "N" : "Y",
          global_id: item.global_id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });

            item.n_is_allow_comment =
              item.n_is_allow_comment == "Y" ? "N" : "Y";
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    operateReward(item) {
      this.$axios
        .post(`${NEWS_HOST}/api/news/setReward`, {
          n_id: item.n_id,
          reward: item.n_reward == 1 ? 0 : 1,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });

            item.n_reward = item.n_reward == 1 ? 0 : 1;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    operateOnlyMe(item, index) {
      this.$axios
        .post(`${NEWS_HOST}/api/user/updateUserNewsData`, {
          id: item.n_id,
          only_me_see: item.n_only_me_see == "1" ? "0" : "1",
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });

            this.list.splice(index, 1);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    operateOnlyMePost(item, index) {
      this.$axios
        .post(`${SWNEWS_HOST}/api/communityMyPost/setOnlyMeSee`, {
          post_id: item.id,
          operate_type: item.only_me_see == "1" ? "0" : "1",
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });

            this.list.splice(index, 1);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    topNow(item) {
      if (item && item.n_id) {
        if (item.is_pinned) {
          this.$axios
            .post(`${SWNEWS_HOST}/api/user/pin`, {
              n_id: item.n_id,
              n_type: item.n_type || item.nm_type || 6,
              n_cover_url: JSON.stringify(
                item.n_cover_url || item.nm_cover_url || item.cover_url || []
              ),
              action: 2,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });

                this.getList();
                //item.is_pinned = false;
                this.topVisible = false;
              } else {
                this.$message.error(res.data.msg);
              }
            });
        } else {
          //this.topItem = item;
          //this.topVisible = true;

          this.$axios
            .post(`${SWNEWS_HOST}/api/user/pin`, {
              n_id: item.n_id,
              n_type: item.n_type || item.nm_type || 6,
              n_cover_url: JSON.stringify(
                item.n_cover_url || item.nm_cover_url || item.cover_url || []
              ),
              action: 1,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });

                this.getList();
                //item.is_pinned = true;
                this.topVisible = false;
              } else {
                this.$message.error(res.data.msg);
              }
            });
        }
      } else {
        this.$axios
          .post(`${SWNEWS_HOST}/api/user/pin`, {
            n_id: this.topItem.n_id,
            n_type: this.topItem.n_type || this.topItem.nm_type || 6,
            n_cover_url: JSON.stringify(
              this.topItem.n_cover_url ||
              this.topItem.nm_cover_url ||
              this.topItem.cover_url ||
              []
            ),
            action: 1,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });

              this.getList();
              //this.topItem.is_pinned = true;
              this.topVisible = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    preview(item) {
      if (item.nm_type == 6 || item.n_type == 6 || this.activeName == 5) {
        this.previewUrlMobile = `https://m.${window.location.href.indexOf("topnews.cn") >= 0 ||
          window.location.href.indexOf("topnews.cn") >= 0
          ? "topnews.cn"
          : "dingnews.net"
          }/c/article-share-new?topicId=${item.encode_id || item.encode_nid}`;
        this.previewUrl = `https://www.topnews.cn/news/${item.encode_id || item.encode_nid
          }`;
      } else if (this.activeName == 4) {
        this.previewUrlMobile =
          (window.location.href.indexOf("topnews.cn") >= 0 ||
            window.location.href.indexOf("topnews.cn") >= 0
            ? "https://m.topnews.cn"
            : "https://m.dingnews.net") +
          (this.packTypeIndex == 0 ? "/scriptList/" : "/videoList/") +
          item.nvpl_series_id;
        this.previewUrl = "";
      } else if (
        window.location.href.indexOf("topnews.cn") >= 0 ||
        window.location.href.indexOf("topnews.cn") >= 0
      ) {
        this.previewUrlMobile = `https://m.topnews.cn/news/${item.encode_id || item.encode_nid
          }`;
        this.previewUrl = `https://www.topnews.cn/news/${item.encode_id || item.encode_nid
          }`;
      } else {
        this.previewUrlMobile = `https://m.dingnews.net/news/${item.encode_id || item.encode_nid
          }`;
        this.previewUrl = "";
      }
      this.viewShow = true;
    },
    /**
     * 关闭预览URL弹窗
     *
     * 功能：
     * 1. 清空预览URL
     * 2. 隐藏预览视图
     */
    previewUrlClose() {
      this.previewUrl = "";
      this.previewUrlMobile = "";
      this.viewShow = false;
    },
    showComments(item) {
      this.scriptActive = item;
      this.commentList = [];
      this.commentPage = 0;
      this.commentBusy = false;
      this.commentVisible = true;

      this.getComments();
    },
    getComments() {
      if (!this.scriptActive.n_id) {
        return;
      }
      this.commentBusy = true;
      this.commentPage++;
      this.$axios
        .post(`${SWNEWS_HOST}/api/comment/list`, {
          n_id: this.scriptActive.n_id,
          type: 1,
          page: this.commentPage,
          page_size: 10,
        })
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((element) => {
              element.reply = "";
              element.showReply = false;

              if (!element.children) {
                element.children = [];
              }

              if (element.children && element.children.length) {
                element.children.forEach((item) => {
                  item.reply = "";
                  item.showReply = false;
                });
              }
            });
            this.commentList = this.commentList.concat(res.data.data);

            this.$nextTick(() => {
              if (res.data.data.length > 0) {
                this.commentBusy = false;
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    moreComment(index) {
      this.$axios
        .post(`${SWNEWS_HOST}/api/comment/list`, {
          n_id: this.scriptActive.n_id,
          type: 2,
          page: 1,
          page_size: 100,
          c_p_id: this.commentList[index].c_id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((element) => {
              element.reply = "";
              element.showReply = false;
            });
            this.commentList[index].children = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    replyToggle(item) {
      let banData = localStorage.getItem("banData");
      if (banData) {
        banData = JSON.parse(banData);
      }

      if (
        !item.showReply &&
        banData.ban_type == 1 &&
        banData.ban_range_type.indexOf("2") > -1
      ) {
        this.$refs.banShow.getReason(localStorage.getItem("token"));
        this.isBanned = true;
      } else {
        item.showReply = !item.showReply;
      }
    },
    commentReply(index, subIndex) {
      let isOne = true;
      if (subIndex !== undefined) {
        // 二级评论
        isOne = false;
      }

      if (
        (isOne
          ? this.commentList[index].reply
          : this.commentList[index].children[subIndex].reply) == ""
      ) {
        return;
      }

      this.$axios
        .post(`${SWNEWS_HOST}/api/comment/comment`, {
          type: 2,
          content: isOne
            ? this.commentList[index].reply
            : this.commentList[index].children[subIndex].reply,
          n_id: this.scriptActive.n_id,
          n_type: this.scriptActive.n_type,
          n_title: this.scriptActive.n_title,
          n_cover_url: JSON.stringify(this.scriptActive.n_cover_url),
          c_id: isOne
            ? this.commentList[index].c_id
            : this.commentList[index].children[subIndex].c_id,
          to_u_id: isOne
            ? this.commentList[index].u_id
            : this.commentList[index].children[subIndex].u_id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "评论成功",
              type: "success",
            });

            if (isOne) {
              this.commentList[index].showReply = false;
              this.commentList[index].reply = "";
            } else {
              this.commentList[index].children[subIndex].showReply = false;
              this.commentList[index].children[subIndex].reply = "";
            }

            this.moreComment(index);
            this.getList();
            this.commentList[index].comment_num++;
            this.scriptActive.comment_num++;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    commentLike(item) {
      this.$axios
        .post(`${NEWS_HOST}/api/fav/favour`, {
          type: 2,
          n_id: this.scriptActive.n_id,
          n_type: this.scriptActive.n_type || 6,
          n_title: this.scriptActive.n_title || this.scriptActive.content,
          n_cover_url:
            JSON.stringify(this.scriptActive.n_cover_url) ||
            JSON.stringify(this.scriptActive.cover_url),
          c_id: item.c_id,
          c_content: item.c_content,
          to_u_id: item.u_id,
          action: item.is_like > 0 ? 1 : 0,
        })
        .then((res) => {
          if (res.data.code == 0) {
            if (item.is_like) {
              item.is_like = 0;
              item.like_num--;
            } else {
              item.is_like = 1;
              item.like_num++;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    commentTop(item) {
      this.$axios
        .post(`${NEWS_HOST}/api/comment/operateTop`, {
          c_id: item.c_id,
          is_top: item.c_is_top > 0 ? 2 : 1,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.commentList = [];
            this.commentPage = 0;
            this.commentBusy = false;

            this.getComments();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    commentDelete(index, subIndex) {
      let isOne = true;
      if (subIndex !== undefined) {
        // 二级评论
        isOne = false;
      }

      this.$confirm("确定要删除该条评论吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`${NEWS_HOST}/api/comment/del`, {
              c_id: isOne
                ? this.commentList[index].c_id
                : this.commentList[index].children[subIndex].c_id,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });

                if (isOne) {
                  // 一级评论删除
                  this.commentList.splice(index, 1);
                } else {
                  // 二级评论删除
                  this.moreComment(index);
                }

                this.getList();
                this.commentList[index].comment_num--;
                this.scriptActive.comment_num--;
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => { });
    },
    /**
     * 复制预览链接到剪切板
     * @param  {String} link 复制的链接
     * @return {Promise<void>}
     */
    handleCopyPreviewLink: async function (link) {
      try {
        await this.$copyText(link);
        this.$message.success("链接复制成功");
      } catch (e) {
        this.$message.error("复制失败");
      }
    },
    findNearesttargetber(arr, target) {
      let mid;
      let l = 0;
      let r = arr.length - 1;
      // 保证指针最终停留在相邻的两个数,所以这里是判断是否大于1
      while (r - l > 1) {
        mid = Math.floor((l + r) / 2);
        // 如果目标数比中间小，所以范围在左边
        if (target < arr[mid]) {
          r = mid;
        } else {
          l = mid;
        }
      }
      return Math.abs(target - arr[l]) <= Math.abs(target - arr[r])
        ? arr[l]
        : arr[r];
    },
    getUserLevelList() {
      this.$axios
        .get(`${SWNEWS_HOST}/api/creatorScore/getUserLevelList`, {})
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.user_privilege_list.forEach((item) => {
              if (item.privilege_name == "评论置顶" && item.is_open == 1) {
                this.topAuth = true;
              } else if (
                item.privilege_name == "用户赞赏" &&
                item.is_open == 1
              ) {
                this.reward_auth = true;
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables";

.copyurl {
  display: flex;
  align-items: center;
  padding: 10px 0;

  .urlTitle {
    color: #666666;
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 400;
    margin-right: 16px;
    line-height: 20px;
  }

  .link {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 16px;
    font-size: 14px;

    /deep/ .el-link {
      width: 100%;
    }

    /deep/ .el-link--inner {
      color: #476eff;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      line-height: 20px;
    }
  }

  .copy-btn {
    border-radius: 12px;
    background: #eceef3;
    cursor: pointer;
    text-align: center;
    width: 72px;
    color: #666666;
    font-family: "PingFang SC";
    font-size: 12px;
    font-weight: 400;
    line-height: 24px;
  }
}

.scriptDrop {
  width: 100%;
  text-align: center;
  display: inline-block;
}

.scriptsExamineListContainer {
  padding: 0 32px;
  position: relative;
  background-color: #ffffff;
  //box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  border-radius: 8px;
  overflow: hidden;

  .certificationInfoContainer {
    /deep/.el-dialog__header {
      padding: 20px 32px;

      .el-dialog__title {
        font-size: 16px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #333333;
        line-height: 22px;
      }
    }

    /deep/.el-dialog__body {
      padding: 10px 32px 41px 32px;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin-bottom: 20px;
      }

      .borderContainer {
        height: 255px;
        border-radius: 6px;
        border: 1px solid #dcdfe6;
        display: flex;
        padding: 28px 32px 0 32px;
        justify-content: space-between;

        div {
          flex: 1;

          .infoTitle {
            font-size: 16px;
            font-family: PingFang-SC-Heavy, PingFang-SC;
            font-weight: 800;
            color: #333333;
            line-height: 22px;
            margin-bottom: 10px;
          }

          .info {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
          }

          .qrCode {
            width: 118px;
            margin: 22px 0 0 117px;
          }

          .app {
            width: 198px;
            margin: 20px 0 0 43px;
          }
        }
      }
    }
  }

  .tabs {
    display: flex;

    li {
      margin: 0 28px;
      font-size: 18px;
      color: #333333;
      cursor: pointer;
      line-height: 69px;
    }

    li.active {
      border-bottom: 3px solid #ea0e0e;
    }
  }

  /deep/.el-range-separator {
    width: 22px !important;
  }

  /deep/.el-tabs__nav-wrap::after {
    height: 0;
  }

  /deep/.el-tabs__nav {
    padding-bottom: 10px;

    .el-tabs__item {
      font-size: 18px;
      color: $text-color-main;
    }
  }

  /deep/.el-tabs__header {
    margin-bottom: 0;
  }

  /deep/.el-dropdown .el-button span {
    font-size: 16px;
  }

  .tab-container {
    width: calc(100% + 64px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 71px;
    border-bottom: 1px solid #eeeeee;
    margin-left: -32px;
    padding-right: 32px;
  }

  .packTypeContain {
    margin-top: 22px;
    margin-bottom: -10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .packInnerContain {
      display: flex;
      align-items: center;
    }

    .packTypeItem {
      font-size: 14px;
      color: #666666;
      margin-right: 20px;
      padding: 3px 9px;
      cursor: pointer;
      border: 1px solid #fff;
    }

    .packTypeActive {
      color: #EA0E0E;
      font-weight: bold;
      border: 1px solid #EA0E0E;
      border-radius: 12px;
    }

    .addPackBtn {
      width: 80px;
      line-height: 26px;
      border-radius: 4px;
      background: #EA0E0E;
      color: #ffffff;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
    }
  }

  .searchContainer {
    margin-top: 32px;
    display: flex;
    align-items: center;

    .el-input {
      width: 220px;
      margin: 0;
    }

    .el-date-editor {
      width: 250px;
      margin-right: 10px;
    }
  }

  .statusBtns {
    margin-top: 16px;
    display: inline-flex;
    font-size: 14px;
    color: $text-color-sub;

    li {
      line-height: 40px;
      margin-right: 20px;
    }

    li.active {
      color: $theme-color;
      font-weight: bold;
    }

    .statusBtn {
      cursor: pointer;
    }
  }

  .innerContainer {
    min-height: calc(100vh - 255px);
    padding-bottom: 20px;

    .el-button {
      margin-right: 10px;
    }

    .el-button+.el-button {
      margin: 0 10px 10px 0;
    }

    .el-pagination {
      float: right;
      margin: 20px 0 0 0;
    }

    .searchKeyInput {
      width: 180px;
    }

    .scriptList {
      li {
        border-bottom: 1px solid #edf1f8;
        padding: 16px 0;
        display: flex;
        min-height: 90px;
        box-sizing: content-box;
        justify-content: space-between;

        .cover-container {
          width: 160px;
          height: 90px;
          border-radius: 6px;
          overflow: hidden;
          background: $img-bg-color;
          margin-right: 20px;
          flex-shrink: 0;

          .cover {
            height: 100%;
            width: 100%;
            object-fit: cover;
            cursor: pointer;
          }
        }

        .info-box {
          flex: 1;
          position: relative;
          width: 0;

          .infoContainer {
            display: flex;
            justify-content: space-between;

            .titleContainer {
              width: calc(100% - 180px);
            }

            .noPassReason {
              font-size: 14px;
              font-family: PingFang SC-常规, PingFang SC;
              font-weight: normal;
              color: #d80c18;
              line-height: 20px;
              background: rgba(215, 12, 24, 0.05);
              padding: 4px 12px;
              margin-top: 12px;
              display: inline-block;
            }

            .title {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              color: $text-color-main;
              font-weight: bold;
              font-size: 16px;
              cursor: pointer;
            }

            .outlineList {
              cursor: default;
            }

            .timeContainer {
              display: flex;
            }

            .create-time {
              color: #999999;
              font-size: 14px;
              margin-left: 8px;
            }

            .status {
              margin: 12px 12px 0 0;

              span {
                display: inline-block;
                padding: 3px 12px;
              }

              @include status() .status-info {
                color: #adb3c8;
                margin-left: 10px;
                font-weight: 800;
              }
            }

            .actionContainer {
              display: flex;
              line-height: 20px;

              .btns {
                margin-left: 20px;
                color: #5574e7;
                font-size: 14px;
                cursor: pointer;
              }
            }
          }

          .infoContainer.action-bar {
            width: 100%;
            margin-top: 13px;

            .userSetTop {
              color: #ea0e0e;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              margin-right: 16px;
            }

            .ext-info {
              color: #999999;

              span {
                margin-right: 20px;
              }
            }

            .actionContainer {
              flex: 1;
              justify-content: flex-end;
            }
          }

          .auditLeft {
            line-height: 30px;
            border-radius: 2px;
            background: #f5f5f5;
            padding: 0 10px;
            color: #999999;
            font-family: "Source Han Serif CN";
            font-size: 12px;
            font-weight: 500;
            margin-top: 10px;
          }
        }
      }
    }

    .el-empty {
      min-height: calc(100vh - 340px);
    }
  }

  /deep/.previewContainer {
    .title {
      font-size: 18px;
      color: #333333;
      margin-right: 24px;
      font-weight: bold;
    }

    .el-link--inner {
      color: #476eff;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 400px;
    }

    .copy-btn {
      padding: 3px 12px;
      background: #eceef3;
      border-radius: 12px;
      color: #666666;
      cursor: pointer;
      margin-left: 10px;
    }

    .el-dialog__body {
      padding-top: 0;
      font-size: 17px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 30px;

      .title {
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 31px;
        margin: 5px 0 10px 0;
      }

      .info {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        img {
          width: 35px;
          height: 35px;
          border-radius: 50%;
          margin-right: 20px;
        }

        .userName {
          font-size: 14px;
          line-height: 20px;
        }

        .time {
          line-height: 18px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }

      video {
        width: 100%;
        margin: 10px auto 10px auto;
        height: auto;
        max-height: 210px;
      }

      .content {
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 24px;

        img {
          max-width: 100%;
          margin: 10px auto 0 auto;
          height: auto;
        }
      }

      .el-carousel {
        margin: 10px 0 15px 0;

        .el-carousel__item {
          .itemContainer {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          p {
            position: absolute;
            right: 16px;
            bottom: 11px;
            background: rgba(0, 0, 0, 0.7);
            border-radius: 24px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
            padding: 0 10px;
          }
        }

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }

  /deep/.commentContainer {
    .el-dialog__body {
      padding-top: 0;

      .scriptActiveContainer {
        width: 840px;
        display: flex;
        margin-bottom: 32px;

        .cover {
          width: 160px;
          height: 90px;
          border-radius: 6px;
          margin-right: 20px;
        }

        .scriptTitle {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 22px;
          height: 66px;
        }

        .scriptTime {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 20px;
          margin-top: 4px;
        }
      }

      .commentCount {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        border-bottom: 1px solid #edf1f8;
        padding-bottom: 16px;
      }

      .commentList {
        height: calc(90vh - 260px);
        overflow-x: hidden;

        li {
          padding: 20px 0;
          border-top: 1px solid #edf1f8;
          position: relative;

          .specialIcon {
            height: 96px;
            position: absolute;
            right: 0;
            top: 10px;
          }

          .headContainer {
            display: flex;
            align-items: center;

            .head {
              width: 28px;
              height: 28px;
              border-radius: 50%;
              margin-right: 12px;
            }

            .userName {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 20px;
            }
          }

          .contentContainer {
            position: relative;
            margin-top: 12px;

            .isTop {
              width: 40px;
              line-height: 20px;
              background: #ea0e0e;
              border-radius: 4px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              text-align: center;
              position: absolute;
              left: 0;
              top: 1px;
            }

            .content {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 22px;
            }

            .contentIsTop {
              text-indent: 45px;
            }
          }

          .commentImg {
            margin-top: 17px;
            display: block;
          }

          .actionContainer {
            margin-top: 17px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .commentTime {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 20px;
            }

            .actions {
              display: flex;

              .action {
                display: flex;
                align-items: center;
                margin-right: 32px;
                cursor: pointer;

                .actionIcon {
                  height: 18px;
                  margin-right: 4px;
                }

                .actionName {
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #333333;
                  line-height: 20px;
                }
              }

              .action:last-child {
                margin-right: 10px;
              }
            }
          }

          .subCommentsContainer {
            padding-left: 40px;

            .toUserName {
              color: rgb(153, 153, 153);
              padding: 0 10px;
            }

            li {
              position: relative;

              .specialIcon {
                height: 96px;
                position: absolute;
                right: 0;
                top: 10px;
              }
            }

            li:last-child {
              padding-bottom: 0;
            }
          }

          .moreComment {
            color: rgb(83, 113, 243);
            font-size: 16px;
            margin: 20px 0 0 40px;
            display: inline-block;
            cursor: pointer;
          }

          .commentReplyContainer {
            width: calc(100% - 10px);
            min-height: 140px;
            background: #f6f7f9;
            border-radius: 4px;
            margin-top: 16px;
            padding-bottom: 12px;

            .el-textarea {
              padding: 12px;
              background: #f6f7f9;
              border: 0;
              min-height: 80px;
              margin-bottom: 12px;

              textarea {
                background: #f6f7f9;
                border: 0;
                padding: 0;
              }
            }

            .replyBtn {
              width: 68px;
              line-height: 36px;
              background: rgba(234, 14, 14, 0.5);
              border-radius: 6px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              text-align: center;
              float: right;
              margin-right: 12px;
            }

            .hasContent {
              background: #ea0e0e;
              cursor: pointer;
            }
          }
        }

        li:first-child {
          border-top: 0;
        }
      }
    }
  }

  /deep/.editTimesContainer {
    .editTimesContent {
      color: #333333;
      font-size: 14px;
      font-weight: 400;
      font-family: "PingFang SC";
      text-align: center;
    }

    .submitBtn {
      width: 80px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      color: #333;
      line-height: 36px;
      display: inline-block;
      margin-left: 12px;
    }

    .submitBtn[type="primary"] {
      width: 80px;
      background-color: #ea0e0e;
      border-color: #ea0e0e;
      color: #fff;
    }
  }

  /deep/.topContainer {
    .el-dialog__header {
      padding-bottom: 0;
    }

    .el-dialog__body {
      padding-top: 0;
      padding-bottom: 0;
      display: flex;
      flex-direction: column;

      .topTitle {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        margin-bottom: 46px;
      }

      .topIntro {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 44px;
      }
    }

    .submitBtn {
      width: 80px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      color: #333;
      line-height: 36px;
      display: inline-block;
      margin-left: 12px;
    }

    .submitBtn[type="primary"] {
      width: 80px;
      background-color: #ea0e0e;
      border-color: #ea0e0e;
      color: #fff;
    }
  }

  /deep/.collectionAddContainer {
    .el-dialog {
      height: 86vh;

      .el-dialog__body {
        padding-top: 10px;
      }

      .collectionAddKeyword {
        width: 350px;
        margin-bottom: 15px;
      }

      .searchNoDataContainer {
        width: 100%;
        height: calc(86vh - 245px);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-top: calc(245px - 86vh);

        .noDataText {
          margin-top: 21px;
          font-size: 20px;
          color: rgb(204, 204, 204);
        }
      }

      .videoCollectContainer {
        width: 100%;
        height: calc(86vh - 245px);
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;

        .scriptListItem {
          width: calc(50% - 15px);
          padding: 8px 0;
          display: flex;
          height: 110px;
          box-sizing: content-box;
          margin-right: 15px;
          cursor: pointer;

          .bgContainer {
            width: calc(100% - 29px);
            background-color: #f6f7f9;
            display: flex;
            padding: 10px;
            border-radius: 5px;
            border: 1px solid #f6f7f9;
          }

          .cover-container {
            width: 160px;
            height: 90px;
            border-radius: 6px;
            overflow: hidden;
            background: #ccc;
            margin-right: 10px;
            flex-shrink: 0;

            .cover {
              height: 100%;
              width: 100%;
            }
          }

          .info-box {
            flex: 1;
            position: relative;
            width: calc(100% - 210px);

            .title {
              width: 100%;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              color: #333333;
              font-weight: bold;
              font-size: 16px;
              line-height: 20px;
              height: 40px;
              margin-bottom: 32px;
            }
          }

          .create-time {
            color: #999999;
            font-size: 14px;
          }
        }

        .collectionAddActive {
          .bgContainer {
            border: 1px solid #EA0E0E;
          }
        }
      }

      .el-dialog__footer {
        margin-top: 10px;

        .dialog-footer {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .collectionAddToCreate {}
        }
      }
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper.is-light.status-info-popper {
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.12);
  color: #ec4e4e;
  border: none;

  .popper__arrow {
    border: none;
  }
}
</style>
